export class EventEmitter {
  constructor() {
    this.callbacks = {};
  }

  on(event, cb) {
    if (!this.callbacks[event]) {
      this.callbacks[event] = [];
    }
    this.callbacks[event].push(cb);
  }

  emit(event, data) {
    const cbs = this.callbacks[event];
    if (cbs) {
      cbs.forEach(cb => cb(data));
    }
    const wildcards = this.callbacks['*'];
    if (wildcards) {
      wildcards.forEach(cb => cb(data));
    }
  }

  handleEmit(event, actions) {
    this.on(event, ([endpoint, payload]) => {
      if (actions[endpoint]) {
        actions[endpoint](payload);
      }
    });
  }
}
